export default __webpack_public_path__ + "static/media/parking.5d065119.jpg";